export default [
  {
    path: '/ir',
    name: 'income_tax',
    component: () => import('./IncomeTax.vue'),
    meta: {
      name: 'Imposto de Renda',
      auth: true,
      user: 'Admin',
    },
  },
]
